<!--<c-footer>-->
 <div class="ms-auto">
    Powered by
    <a href="https://bamboosoft.ca/" target="_blank">
      <span> {{ currentYear }} Bamboosoft Inc.</span>
    </a>
  </div>
<!--</c-footer>-->
